@if (!stateRegister) {
  <mat-form-field>
    <input spellcheck="false" autocomplete="off" (ngModelChange)="codeChange($event)" [(ngModel)]="code" ngDefaultControl placeholder="Access Code" matInput />
  </mat-form-field>
  <div (click)="stateRegister = true" class="hint">Get the Access Code</div>
}
@if (stateRegister) {
  @if (!(granted | async)) {
    <h2>Please enter the information to obtain (or receive) the access code</h2>
    <br />
    <div>Required *</div>
    <form [formGroup]="rForm" spellcheck="false" autocomplete="off" (ngSubmit)="submit(rForm.value)">
      <mat-form-field>
        <input formControlName="name" ngDefaultControl placeholder="Name *" matInput />
      </mat-form-field>
      <mat-form-field>
        <input formControlName="email" type="email" ngDefaultControl placeholder="Email *" matInput />
      </mat-form-field>
      <mat-form-field>
        <input onlyNumbers formControlName="tel" ngDefaultControl placeholder="Telephone *" matInput />
      </mat-form-field>
      <button class="access" [disabled]="!rForm.valid" mat-raised-button>Submit</button>
    </form>
  }
  @if (granted | async) {
    <div class="the-code">We have sent you an email with the access code, also review the spam folder.</div>
  }
  <div (click)="stateRegister = false" class="hint">Return</div>
}